import { TRootState } from 'Redux/Reducers';
import { arrayContains } from 'utils';
import Actions from 'Redux/Actions';

export const isPaymentFailed = (state: TRootState): boolean =>
  arrayContains(state.payment.failedRequests, [Actions.stripeSetupIntentFailure.type, Actions.confirmPaymentMethodFailure.type]);
